import ajax from '../utils/request'
import ArticleService from './article.service'

/**
 * HomeService
 * @module service/Home
 */
export default {
  /**
   * 首页基础数据
   * @fires public/v1/article/getIndexList:baseList
   */
  baseList () {
    /**
     * 执行读取首页基础数据的接口
     * @see http://zentao.geekbang.org/zentao/doc-view-469.html#wow1
     * @event public/v1/article/getIndexList:baseList
     * @returns {Object}          res                   数据
     * @returns {Boolean}         res.is_sub            是否已订阅每周精要 [0:未订阅,1:已订阅]
     * @returns {Array<Object>}   res.recommend_list    精选内容
     * @returns {Array<Object>}   res.book_list         迷你书
     * @returns {Array<Object>}   res.hot_day_list      7 天内的热点新闻
     * @returns {Array<Object>}   res.hot_month_list    1 个月内的热点新闻
     * @returns {Array<Object>}   res.hot_year_list     6 个月内的热点新闻
     */
    return ajax({
      type: 'get',
      url: 'public/v1/article/getIndexList'
    }).then(res => {
      // res.book_list = res.book_list.map(book => ArticleService.parseArticleAuthor(book))
      res.hot_day_list = res.hot_day_list || []
      res.hot_month_list = res.hot_month_list || []
      res.hot_year_list = res.hot_year_list || []
      return res
    })
  },
  /**
   * 首页快讯列表
   * @emits  public/v1/news/list:getNews
   * @param {Number}  [score]  翻页的标识
   * @return {Array<Object>}   返回的数据与接口一致
   */
  getNews (score) {
    const postData = {
      size: 6
    }

    if (score) {
      postData.score = score - 0
    }

    /**
     * 执行获取首页快讯列表的接口
     * @event  public/v1/news/list:getNews
     * @param  {Object}    data          body data
     * @param  {Number}   [data.size]    展示数量
     * @param  {String}   [data.alias]   分页标识
     * @return {Array<Object>}  res  返回数据
     * @return {String}     res.id   新闻 ID
     * @return {Number}     res.score   新闻每条的标书，分页使用
     * @return {String}     res.title   新闻标题
     * @return {String}     res.content   新闻内容
     * @return {URL}        res.url   新闻链接
     * @return {Timestamp}  res.time   新闻发布时间
     */
    return ajax({
      url: 'public/v1/news/list',
      data: postData
    })
  },
  /**
   * 首页推荐列表
   * @emits public/v1/my/recommond:getRcommond
   * @param {String} data             参数
   * @param {Number} [data.score]     分页标识, 空值为第一页
   * @param {Number} [data.size=12]   页面大小
   * @return {Array<Object>}  res        返回数据基本与接口一致
   * @return {Number}         res.type   数据类型 [1:文章, 2:广告]
   * @return {Object}  res.recommond        关注的频道或者作者的数据
   * @return {Number}  res.recommondLength  关注维度的数量
   */
  getRcommond (data) {
    const postData = {
      size: data.size | 0 || 12
    }

    // 分页标识 默认为第一页
    if (data.score) {
      postData.score = data.score - 0
    }

    /**
     * 执行获取首页 feed 流数据的接口
     * @see https://yapi.geekbang.org/project/116/interface/api/1281
     * @event public/v1/my/recommond:getRcommond
     * @return {Array<Object>}      res      返回的文章数据
     * @return {Array<Object>}      res.sub_author     同 author
     * @return {Array<Object>}      res.sub_topic      同 topic
     */
    return ajax({
      url: 'public/v1/my/recommond',
      data: postData
    })
    .then(res => {
      return res.map(item => {
        item = ArticleService.parseArticleAuthor(item)

        if (item.type !== 1) {
          return item
        } else {
          if (item.sub_author || item.sub_topic) {
            // 推荐方优先取关注的作者，之后是频道
            const arrRecommond = [...item.sub_author, ...item.sub_topic]
            const recommond = arrRecommond.length ? arrRecommond[0] : null
            return Object.assign(item, {
              recommond,
              recommondLength: arrRecommond.length
            })
          } else {
            return item
          }
        }
      })
    })
  },
  /**
   * 获取是否已订阅周刊
   * @emits public/v1/user/subEmail:getSubWeek
   */
  getSubWeek () {
    /**
     * 执行获取是否已订阅周刊的接口
     * @event public/v1/user/subEmail:getSubWeek
     * @return {Boolean} is_sub   是否已订阅
     */
    return ajax({
      type: 'get',
      url: 'public/v1/user/subEmail'
    })
  },
  /**
   * 每周订阅
   * @param {Object} data         每周订阅
   * @param {String} data.email   邮箱
   */
  subWeek (data) {
    return ajax({
      signin: true,
      url: 'public/v1/user/addEmail',
      data: data
    })
  },
  sendSubWeekEmailCode (data) {
    return ajax({
      url: 'public/v1/user/captchEmail',
      data: data
    })
  },
  /**
   * @see https://yapi.geekbang.org/project/116/interface/api/6712
   * @param {Number} offset           偏移量
   */
  getHomeRecommendTalk (offset) {
    let data = {
      offset,
      limit: 3
    }
    return ajax({
      url: 'public/v1/topic/get_recommend_list',
      data: data
    })
  }
}
